<div class="topbar">
  <div class="left-section">
    <span class="logo-icon"></span>
    <span class="logo-seperator"></span>
    <kendo-label class="primarycompany"
      ><b>{{ primaryCompanyName$ | async }}</b></kendo-label
    >
    <div class="nav-links">
      <a
        href="#"
        [ngClass]="{
          'nav-link-active': currentUrl === '/' || currentUrl === '/dashboard',
        }"
        class="nav-link"
        >{{ 'TOP_NAV.DASHBOARD' | translate }}</a
      >
      <a
        href="maps"
        [ngClass]="{ 'nav-link-active': currentUrl === '/maps' }"
        class="nav-link map-link"
        >{{ 'TOP_NAV.MAP' | translate }}</a
      >
    </div>
  </div>
  <div class="right-section">
    <div class="dropdown">
      <button
        class="btn dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {{ selectedName }}
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li *ngFor="let country of countries" (click)="changeLanguage(country)">
          <a class="dropdown-item" style="cursor: pointer">
            {{ country.name }}
          </a>
        </li>
      </ul>
    </div>

    <a [href]="helpUrl" target="_blank" rel="noopener">
      <button mat-icon-button class="settings-btn">
        <mat-icon class="right-section-icon questionMarkIcon"></mat-icon>
      </button>
    </a>
    <div class="user-info">
      <span class="avatar"></span>
      <div class="user-details">
        <p class="greeting">Hello</p>
        <p class="username">
          <b>{{ loggedInName$ | async }}</b>
        </p>
      </div>
    </div>
    <button
      kendoButton
      #anchor
      class="usersettings-btn"
      (click)="userSettingClicked()"
    ></button>
    <app-profile-menu
      class="profile-menu"
      (click)="$event.stopPropagation()"
      (closePopup)="closeUserSettings()"
      *ngIf="isUserSettingPopUpOpen"
    ></app-profile-menu>
  </div>
</div>
